import { render, staticRenderFns } from "./DemoCarousel.vue?vue&type=template&id=a9e6927c&scoped=true"
import script from "./DemoCarousel.vue?vue&type=script&lang=js"
export * from "./DemoCarousel.vue?vue&type=script&lang=js"
import style0 from "./DemoCarousel.vue?vue&type=style&index=0&id=a9e6927c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e6927c",
  null
  
)

export default component.exports